/**
 * Soma um valor ao valor atual.
 *
 * @param {number|string} x - Valor atual.
 * @param {number|string} y - Valor a ser somado.
 * @returns {number}
 */
export function add(x, y) {
  return Number(x) + Number(y);
}
